<template>

    <div>
        <b-table :items="value.map((ir, ix) => ({ index: ix, value: ir }))" :fields="[
            { key: 'value', label: '' },
            { key: 'actions', label: '', class: 'actions' }
        ]" class="mb-0 hide-header" small bordered>
            <template #cell(value)="{ item, index }">
                <b-input v-if="editingRowIndex === index" v-model.number="editingRowData" :value="item.value" autofocus
                    type="number"/>
                <template v-else>{{ item.value }}</template>
            </template>
            <template #cell(actions)="{ item, index }">
                <div class="d-flex" style="gap: 6px;">
                    <template v-if="editingRowIndex !== index">
                        <b-button variant="link" @click.prevent="startTableEdit(item, index)" title="Edit">
                            <b-icon icon="pencil" variant="primary"/>
                        </b-button>
                        <b-button variant="link" @click.prevent="removeTableItem(index)" title="Remove">
                            <b-icon icon="x-circle-fill" variant="danger"/>
                        </b-button>
                    </template>
                    <template v-else>
                        <b-button variant="link" title="Save" @click.prevent="saveTableEdit(index)">
                            <b-icon icon="save" variant="primary"/>
                        </b-button>
                        <b-button variant="link" title="Cancel Edit" @click.prevent="cancelTableEdit">
                            <b-icon icon="x-lg" variant=""/>
                        </b-button>
                    </template>
                </div>
            </template>
        </b-table>

        <b-button size="sm" variant="primary" @click="addTableItem">
            {{ addLabel ?? "Add" }}
        </b-button>
    </div>

</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
    name: "NumberArrayField",
})
export default class NumberArrayField extends Vue {
    @Prop({ default: () => [], type: Array }) value!: number[];
    @Prop({ default: 'Add', type: String }) addLabel!: String;

    private editingRowData: number | undefined = undefined;
    private editingRowIndex: number = -1;

    startTableEdit(item: { value: number | undefined }, index: number) {
        this.editingRowIndex = index;
        this.editingRowData = item.value;
    }

    cleanArray(numbers: number[]): Array<number | undefined> {
        const numberSet = new Set(numbers.filter(a => !isNaN(a)));
        const deDupedArray = [...numberSet];
        return deDupedArray.sort((a, b) => a - b);
    }

    addTableItem() {
        const cleanedArray = this.cleanArray(this.value);
        cleanedArray.push(undefined);
        this.$emit('input', cleanedArray);
        this.startTableEdit({ value: undefined }, cleanedArray.length - 1);
    }

    removeTableItem(index: number) {
        let array = [...this.value];
        array.splice(index, 1);
        array = array.filter(a => !isNaN(a));
        this.$emit('input', array);
    }

    cancelTableEdit() {
        const editingIndex = this.editingRowIndex;
        const editingValue = this.value[editingIndex];
        if (!editingValue) {
            this.removeTableItem(editingIndex);
        }
        this.editingRowIndex = -1;
    }

    saveTableEdit(index: number) {
        const array = [...this.value];
        const newValue = this.editingRowData;
        if (Number.isNaN(newValue)) {
            array.splice(index, 1);
        } else {
            array.splice(index, 1, newValue!);
        }

        this.$emit('input', this.cleanArray(array));
        this.editingRowIndex = -1;
    }
}

</script>

<style scoped lang="scss">
table.hide-header ::v-deep(thead) {
    display: none;
}

table ::v-deep(.actions) {
    width: 50px;
}
</style>
